import { PUBLIC_ENVIRONMENT } from '../config/env';
import { numberToHexString } from '../lib/utils/string';
import { TokenType } from '../types';

export const NATIVE_ETH_LOGO =
  'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/info/logo.png';

export const ChainIds = {
  MAINNET: 1,
  ARBITRUM_DEMO: 412346,
};

export const routerAddress = new Map();
routerAddress.set(
  ChainIds.MAINNET,
  '0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D',
);
routerAddress.set(
  ChainIds.ARBITRUM_DEMO,
  '0xBd7f7c83BdBABfD65a98c6D2AFc9261F3d2Eb03B',
);

export const pairAddress = new Map();
pairAddress.set(
  ChainIds.ARBITRUM_DEMO,
  '0x92eb464adb1bbf6f44e963745e16eb0b83b5908b',
);

export const customChain = {
  id: 412346,
  name: 'Arbitrum Demo',
  network: 'arbitrum-demo',
  nativeCurrency: {
    name: 'Ether',
    symbol: 'ETH',
    decimals: 18,
  },
  rpcUrls: {
    default: { http: [PUBLIC_ENVIRONMENT.REACT_APP_ARBITRUM_RPC_URL] },
  },
  blockExplorers: {
    default: {
      name: 'Arbitrum Demo Explorer',
      url: PUBLIC_ENVIRONMENT.REACT_APP_ARBITRUM_EXPLORER_URL,
    },
  },
  testnet: true,
};

export const customChainToAddMetamask = {
  chainId: numberToHexString(412346),
  chainName: 'Arbitrum Demo',
  rpcUrls: [PUBLIC_ENVIRONMENT.REACT_APP_ARBITRUM_RPC_URL],
  iconUrls: [
    'https://arbitrum.io/logo_monochrome.svg',
    'https://arbitrum.io/logo_monochrome.svg',
  ],
  nativeCurrency: {
    name: 'Ether',
    symbol: 'ETH',
    decimals: 18,
  },
  blockExplorerUrls: [PUBLIC_ENVIRONMENT.REACT_APP_ARBITRUM_EXPLORER_URL],
};

export const ARBITRUM_DEMO_TOKEN_LIST: TokenType[] = [
  {
    name: 'USDC',
    address: '0x84401CD7AbBeBB22ACb7aF2beCfd9bE56C30bcf1',
    symbol: 'USDC',
    decimals: 18,
    chainId: 412346,
    logoURI:
      'https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png',
    native: false,
  },
  {
    name: 'Wrapped ETH',
    address: '0xb8F30164C4D1f62155F7a1115E68e605069689E4',
    symbol: 'WETH',
    decimals: 18,
    chainId: 412346,
    logoURI:
      'https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png',
    native: false,
  },
  {
    name: 'Tether',
    address: '0xd9bF5428C4a93aA2DEdd0161F299071b9D1FEc0a',
    symbol: 'USDT',
    decimals: 18,
    chainId: 412346,
    logoURI:
      'https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xdAC17F958D2ee523a2206206994597C13D831ec7/logo.png',
    native: false,
  },
];

export const FAIRYRING_PUBKEY =
  '80c2a2e4d44957e4a35f248e2fa7dd364803e70a047b5cacdb1e02c81be17ed55bdc79e048cfa0526cbc84c1b40dd1ca';

export const MENU_ITEMS = [
  {
    title: 'Swap',
    href: '/swap',
  },
  {
    title: 'Track',
    href: '/track',
  },
  {
    title: 'Faucet',
    href: '/faucet',
  },
];
